import { IModalite } from './modalite.i';

export class CModalite implements IModalite {
  id = 0;
  libelle = '';

  constructor(source?: IModalite) {
    if (source) {
      Object.assign(this, {
        id: source.id,
        libelle: source.libelle
      });
    }
  }
}
